import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Heart, Eye } from "lucide-react";
import { ProductImages } from "../assets/ProductImages";

export default function ProductCard({ product, index, onView }) {
  const [liked, setLiked] = useState(false);
  const [hovered, setHovered] = useState(false);

  const ImageComponent = ProductImages[product.imageType];

  return (
    <motion.div
      className="product-card"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ delay: (index % 4) * 0.08, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      onHoverStart={() => setHovered(true)}
      onHoverEnd={() => setHovered(false)}
      style={{ "--accent": product.accent }}
    >
      {/* Image area */}
      <div className="card-image-wrap">
        <div className="card-image-bg" style={{ background: product.color }} />
        {product.image ? (
          <img src={product.image} alt={product.name} className="card-photo" />
        ) : (
          ImageComponent && <ImageComponent accent={product.accent} />
        )}

        {/* Overlay on hover */}
        <AnimatePresence>
          {hovered && (
            <motion.div
              className="card-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              <motion.button
                className="overlay-btn"
                initial={{ y: 10 }}
                animate={{ y: 0 }}
                onClick={() => onView?.(product)}
              >
                <Eye size={14} /> Quick View
              </motion.button>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Tag */}
        {product.tag && (
          <div className="card-tag" style={{ background: product.accent, color: "#fff" }}>
            {product.tag}
          </div>
        )}

        {/* Wishlist */}
        <button
          className={`card-wish ${liked ? "liked" : ""}`}
          onClick={(e) => { e.stopPropagation(); setLiked(!liked); }}
        >
          <Heart size={15} fill={liked ? product.accent : "none"} color={liked ? product.accent : "currentColor"} />
        </button>
      </div>

      {/* Info */}
      <div className="card-info">
        <div className="card-category">{product.category.toUpperCase()}</div>
        <h3 className="card-name">{product.name}</h3>
        <p className="card-subtitle">{product.subtitle}</p>
        <p className="card-desc">{product.description}</p>
        <div className="card-footer">
          <span className="card-contact-hint">Contact us for details</span>
          <button className="card-add" onClick={() => onView?.(product)} aria-label="View product">
            <Plus size={16} />
          </button>
        </div>
      </div>

      {/* Bottom accent line */}
      <motion.div
        className="card-accent-line"
        style={{ background: product.accent }}
        initial={{ scaleX: 0 }}
        animate={{ scaleX: hovered ? 1 : 0 }}
        transition={{ duration: 0.3 }}
      />
    </motion.div>
  );
}
